export default __webpack_public_path__ + "static/media/clouds@1x.14c2be57.webp";